<script>
import Layout from '@layouts/main.vue'
import { authMethods } from '@state/helpers'
import analyticsService from '@utils/analytics-service'

export default {
  page: {
    title: 'Password Reset',
    meta: [{ name: 'passwordreset', content: `Request password reset` }],
  },
  components: { Layout },
  data() {
    return {
      email: '',
      isWorking: false,
    }
  },
  computed: {
    placeholders() {
      return {
        username: 'E-mail Address',
      }
    },
  },
  mounted() {
    analyticsService.trackPageView('Password reset')
  },
  methods: {
    ...authMethods,
    // Try to log the user in with the username
    // and password they provided.
    tryRequestPasswordReset() {
      this.isWorking = true
      // Reset the authError if it existed.
      this.authError = null
      return this.requestPasswordReset({
        email: this.email,
      })
        .then((res) => {
          this.isWorking = false

          this.$swal.fire({
            title: 'Success!',
            text: res.message,
            icon: 'success',
          })
        })
        .catch((error) => {
          this.isWorking = false

          this.$swal.fire({
            title: 'Error',
            text: error.response.data.message,
            icon: 'error',
          })
        })
    },
  },
}
</script>

<template>
  <Layout>
    <form :class="$style.form" @submit.prevent="tryRequestPasswordReset">
      <BaseInputText
        v-model="email"
        name="email"
        placeholder="Enter your email address"
      />
      <BaseButton :disabled="isWorking" type="submit">
        <BaseIcon v-if="isWorking" name="sync" spin />
        <span v-else>
          Submit
        </span>
      </BaseButton>
    </form>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.form {
  text-align: center;
}
</style>
